import React from "react";
import "./App.scss";
import MainRouter from "./Router/MainRouter";
import Header from "./Components/Header";
import { DocumentsProvider } from "./Hooks/DocumentsProvider";
import Footer from "./Components/Footer";

function App() {
  return (
    <DocumentsProvider>
      <div className="App">
        <Header />
        <main className="main-content">
          <MainRouter />
        </main>
        <Footer />
      </div>
    </DocumentsProvider>
  );
}

export default App;
